import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import moment from 'moment'
import axios from 'axios'
import './assets/css/style.css'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import Multiselect from '@vueform/multiselect'

import Swal from 'sweetalert2'
import Pagination from './components/Common/Pagination.vue'
import ImageViewer from './components/Common/ImageViewer.vue'
import ReadMore from './components/Common/ReadMore.vue'

const app = createApp(App)

app.use(ElementPlus)
app.component('Multiselect', Multiselect)
app.component('Pagination', Pagination)
app.component('ImageViewer', ImageViewer)
app.component('ReadMore', ReadMore)

// Register tabs components globally
app.component('ElTabs', ElementPlus.ElTabs)
app.component('ElTabPane', ElementPlus.ElTabPane)

let baseUrl = "https://leadhub.corelto.co/api"
if(process.env.NODE_ENV === 'production'){
  baseUrl = "https://leadhub.corelto.co/api"
}
axios.defaults.baseURL = baseUrl;

//axios interceptors
axios.interceptors.request.use(function(config) {
  store.dispatch('setLoading', true);
  if(config.url.indexOf('login') < 0){
    let token = localStorage.getItem('property-user-token')
    if(token){
      config.headers.Authorization = `Token token=${token}`
    }
  }
  config.headers['Content-Type'] = 'application/json'
  config.headers['Accept'] = 'application/json'
  return config;
}, function(err) {
  store.dispatch('setLoading', false);
  return Promise.reject(err);
});

axios.interceptors.response.use(function(response) {
  store.dispatch('setLoading', false);
  return response;
}, function(error){
  if(error.response.status === 401){
    const hadToken = !!localStorage.getItem('property-user-token');
    localStorage.removeItem('property-user-token');
    
      if (hadToken) {
      Swal.fire({
        title: "Session Expired",
        text: "You have been redirected to the login page",
        icon: "error"
      })
      .then(() => router.replace('/login'));
    } else {
      router.replace('/login');
    }
  }else{
    store.dispatch('setLoading', false);
    return Promise.reject(error);
  }
});

router.beforeEach((to, from, next) => {
  let token = localStorage.getItem('property-user-token')
  if(token && to.name === 'Login'){
    next({name: 'Home'});
  }else if(to.name !== 'Login' && !token){
    next({name: 'Login'});
  }else{
    if(to.name === 'Login'){
      store.dispatch('setLayout', 'login');
    }else{
      store.dispatch('setLayout', 'default');
    }
    next();
  }
})

// Global properties in Vue 3
app.config.globalProperties.$moment = moment;
app.config.globalProperties.$axios = axios;
app.config.globalProperties.$swal = Swal;

// Global utility functions in Vue 3
app.config.globalProperties.$dateFormat = function (value) {
  if (!value) return '-'
  return moment(value).format('DD-MMM-YYYY')
}

app.config.globalProperties.$asINR = function(value){
  if(!value) return '0'
  return value.toLocaleString('en-IN')
}

app.use(router)
app.use(store)
app.mount('#app')